import { api } from './baseApi';
export var productsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getProducts: builder.query({
                query: function () {
                    return ({
                        url: '/products',
                        method: 'GET',
                    });
                },
                providesTags: ['Products'],
            }),
            createProduct: builder.mutation({
                query: function (body) {
                    return ({
                        url: '/products',
                        method: 'POST',
                        body: body,
                    });
                },
                invalidatesTags: ['Products'],
            }),
            updateProduct: builder.mutation({
                query: function (_a) {
                    var id = _a.id, body = _a.body;
                    return ({
                        url: "/products/".concat(id),
                        method: 'PUT',
                        body: body,
                    });
                },
                invalidatesTags: ['Products'],
            }),
            deleteProduct: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/products/".concat(id),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['Products'],
            }),
        });
    },
});
export var useGetProductsQuery = productsApi.useGetProductsQuery, useCreateProductMutation = productsApi.useCreateProductMutation, useUpdateProductMutation = productsApi.useUpdateProductMutation, // 👈 добавлен хук обновления
useDeleteProductMutation = productsApi.useDeleteProductMutation;
